module.exports = __webpack_public_path__ + "img/30f5.4515cbf0.jpg";